import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./StudentForm.css";

const API_BASE_URL = 'https://upskld.co/api/student';

const validationSchema = Yup.object({
  studentName: Yup.string()
    .trim()
    .min(2, 'Name should be at least 2 characters')
    .required('Student name is required'),
  email: Yup.string()
    .email('Enter a valid email address')
    .required('Email is required'),
  collegeName: Yup.string()
    .trim()
    .min(2, 'College name should be at least 2 characters')
    .required('College name is required'),
  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits')
    .required('Phone number is required'),
  feedback: Yup.string()
    .trim()
    .required('Feedback is required'),
  willingForAiCourse: Yup.boolean(),
});

const StudentForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik({
    initialValues: {
      studentName: '',
      email: '',
      collegeName: '',
      phoneNumber: '',
      feedback: '',
      willingForAiCourse: false,
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true);
      try {
        await axios.post(API_BASE_URL, values);
        toast.success('Form submitted successfully!');
        resetForm();
      } catch (err) {
        console.error('Student form submit error:', err);
        toast.error('Something went wrong. Please try again.');
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <div className="student_form_wrapper">
          
    <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
      
      <div className="student_form_card">

  
        <h2 className="student_form_title">Student Feedback Form</h2>

        <form className="student_form_form" onSubmit={formik.handleSubmit} noValidate>
          {/* Student Name */}
          <div className="student_form_group">
            <label className="student_form_label" htmlFor="studentName">
              Student Name
            </label>
            <input
              id="studentName"
              name="studentName"
              type="text"
              className="student_form_input"
              placeholder="Enter your full name"
              value={formik.values.studentName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.studentName && formik.errors.studentName && (
              <span className="student_form_error">{formik.errors.studentName}</span>
            )}
          </div>

          {/* Email */}
          <div className="student_form_group">
            <label className="student_form_label" htmlFor="email">
              Email ID
            </label>
            <input
              id="email"
              name="email"
              type="email"
              className="student_form_input"
              placeholder="Enter your email id"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.email && formik.errors.email && (
              <span className="student_form_error">{formik.errors.email}</span>
            )}
          </div>

          {/* College Name */}
          <div className="student_form_group">
            <label className="student_form_label" htmlFor="collegeName">
              College Name
            </label>
            <input
              id="collegeName"
              name="collegeName"
              type="text"
              className="student_form_input"
              placeholder="Enter your college name"
              value={formik.values.collegeName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.collegeName && formik.errors.collegeName && (
              <span className="student_form_error">{formik.errors.collegeName}</span>
            )}
          </div>

          {/* Phone Number */}
          <div className="student_form_group">
            <label className="student_form_label" htmlFor="phoneNumber">
              Phone Number
            </label>
            <input
              id="phoneNumber"
              name="phoneNumber"
              type="tel"
              inputMode="numeric"
              maxLength={10}
              className="student_form_input"
              placeholder="Enter 10 digit phone number"
              value={formik.values.phoneNumber}
              onChange={(e) => {
                const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 10);
                formik.setFieldValue('phoneNumber', onlyDigits);
              }}
              onBlur={formik.handleBlur}
            />
            {formik.touched.phoneNumber && formik.errors.phoneNumber && (
              <span className="student_form_error">{formik.errors.phoneNumber}</span>
            )}
          </div>

          {/* Feedback */}
          <div className="student_form_group">
            <label className="student_form_label" htmlFor="feedback">
              Feedback
            </label>
            <textarea
              id="feedback"
              name="feedback"
              rows={2}
              className="student_form_textarea"
              placeholder="Enter your feed back"
              value={formik.values.feedback}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.feedback && formik.errors.feedback && (
              <span className="student_form_error">{formik.errors.feedback}</span>
            )}
          </div>

          {/* Willing for AI Course - Checkbox */}
          <div className="student_form_checkbox_group">
            <input
              id="willingForAiCourse"
              name="willingForAiCourse"
              type="checkbox"
              className="student_form_checkbox"
              checked={formik.values.willingForAiCourse}
              onChange={formik.handleChange}
            />
            <label className="student_form_checkbox_label" htmlFor="willingForAiCourse">
              Willing to AI course
            </label>
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="student_form_submit_btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default StudentForm;